import React from 'react'
import { Box, Fade, Grid } from '@mui/material'
import LanguageSelect from '@imports/LanguageSelect'

import SchoolBagIcon from '@assets/icons/register-drawings.svg'
import SchoolBagSmallIcon from '@assets/icons/register-drawings-small.svg'

import InstructionsSection from './components/InstructionsSection'
import CreateAccountSection from './components/CreateAccountSection'
import AccountInfoSection from './components/AccountInfoSection'
import LoadingSection from './components/LoadingSection'

export function RegisterSection() {
  const [active, setActive] = React.useState('instructions')
  const [data, setData] = React.useState({})
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <Grid
        container
        flexDirection="column"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              display: { xs: 'none', md: 'block' },
              zIndex: -1,
            }}
          >
            <SchoolBagIcon
              width="100%"
              height="100%"
            />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              display: { xs: 'block', md: 'none' },
              zIndex: -1,
            }}
          >
            <SchoolBagSmallIcon
              width="100%"
              height="100%"
            />
          </Box>
          <Fade
            in={active === 'instructions'}
            sx={{ display: active === 'instructions' ? '' : 'none' }}
          >
            <Box>
              <InstructionsSection handleSkip={() => setActive('register')} />
            </Box>
          </Fade>
          <Fade
            in={active === 'register'}
            sx={{ display: active === 'register' ? '' : 'none' }}
          >
            <Box>
              <CreateAccountSection
                handleBack={() => setActive('register')}
                handleNext={() => setActive('post-register')}
                data={data}
                setData={setData}
              />
            </Box>
          </Fade>
          <Fade
            in={active === 'post-register'}
            sx={{ display: active === 'post-register' ? '' : 'none' }}
          >
            <Box>
              <AccountInfoSection
                handleNext={() => setActive('pending')}
                data={data}
                setData={setData}
              />
            </Box>
          </Fade>
          <Fade
            in={active === 'pending'}
            sx={{ display: active === 'pending' ? '' : 'none' }}
          >
            <Box>
              <LoadingSection
                active={active === 'pending'}
                data={data}
              />
            </Box>
          </Fade>
        </Grid>
        <Grid
          item
          flexGrow={1}
          justifyContent="center"
          alignItems="flex-end"
          container
        >
          <Grid
            item
            sx={{ my: 2 }}
          >
            <LanguageSelect />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default RegisterSection
